import { Path, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

import ChevronDownIcon from "src/core/assets/images/icons/chevronDown.svg?react";
import ChevronUpIcon from "src/core/assets/images/icons/chevronUp.svg?react";
import ContactIcon from "src/core/assets/images/icons/contact.svg?react";
import { FormInput } from "src/core/components/custom-ui/form-input";
import { ContactInformationFieldsValues } from "src/core/forms/create-client/contactInformations.schema";

type ContactInformationFieldsProps<T extends ContactInformationFieldsValues> = {
  form: UseFormReturn<T>;
  setShowContactInfo?: (open: boolean) => void;
  showContactInfo?: boolean;
};

export const ContactInformationFields = <T extends ContactInformationFieldsValues>({
  form,
  setShowContactInfo,
  showContactInfo = true,
}: ContactInformationFieldsProps<T>) => {
  const { t } = useTranslation();

  return (
    <div className="mt-10">
      <div className="contact-information-header-title">{t("form.createClient.contactInfo")}</div>
      <div className="contact-information-card">
        <div className="flex flex-col my-10 border-border px-10 rounded-lg relative">
          <div
            className="flex flex-row items-center justify-between"
            role="button"
            onClick={() => setShowContactInfo?.(!showContactInfo)}
          >
            <div className="flex flex-row items-center gap-x-10">
              <ContactIcon className="text-foreground" />
              <div className="uppercase font-light text-xs">
                {t("form.createClient.contactInfoTitle")}
              </div>
            </div>
            {setShowContactInfo !== undefined &&
              (showContactInfo ? (
                <ChevronUpIcon className="text-foreground" />
              ) : (
                <ChevronDownIcon className="text-foreground" />
              ))}
          </div>
          {showContactInfo && (
            <>
              <div className="flex flex-row">
                <FormInput<T>
                  control={form.control}
                  name={"prenom" as Path<T>}
                  label={t("form.createClient.firstName")}
                  className="w-[330px]"
                />
                <div className="ml-[50px]">
                  <FormInput<T>
                    control={form.control}
                    name={"nom" as Path<T>}
                    label={t("form.createClient.lastName")}
                    className="w-[330px]"
                  />
                </div>
              </div>
              <div className="flex flex-row mb-5">
                <FormInput<T>
                  control={form.control}
                  name={"email" as Path<T>}
                  label={t("form.createClient.email")}
                  className="w-[330px]"
                />
                <div className="ml-[50px]">
                  <FormInput<T>
                    control={form.control}
                    name={"telephone" as Path<T>}
                    label={t("form.createClient.phone")}
                    className="w-[330px]"
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
